import { Loader, LoaderOptions } from 'google-maps';

import { flagService } from '../core/services/flagService/flagService';
import { GoogleTools } from './Data';

export const LoadMaps = (googleMapsApiKey: string): Promise<GoogleTools> =>
  new Promise<GoogleTools>((resolve) => {
    const options: LoaderOptions = {
      libraries: ['geometry', 'places'],
    };
    if (typeof google !== 'undefined' && google?.maps) {
      resolve({
        AutoComplete: new google.maps.places.AutocompleteService(),
        GeoCoder: new google.maps.Geocoder(),
      });
      return;
    }
    const useDOMAKey = flagService.isFlagOn('useDOMAKey');
    const apiKeyFromEnv = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const apiKey = useDOMAKey ? googleMapsApiKey : apiKeyFromEnv;

    const loader = new Loader(apiKey, options);

    loader.load().then((google) => {
      resolve({
        AutoComplete: new google.maps.places.AutocompleteService(),
        GeoCoder: new google.maps.Geocoder(),
      });
    });
  });

export default LoadMaps;
